// extracted by mini-css-extract-plugin
export var optionGrid = "_bj-7";
export var optionList = "_bj-6";
export var questionsBlock = "_bj-9";
export var spacer = "_bj-5";
export var stepCenteredContent = "_bj-3";
export var stepInner = "_bj-0";
export var stepInnerFullWidth = "_bj-1";
export var stepInnerLockScroll = "_bj-2";
export var stepTransitionFrame = "_bj-4";
export var welcomeBlock = "_bj-8";